import { render, staticRenderFns } from "./VSidebarLayoutHeading.vue?vue&type=template&id=50c61de6&scoped=true&"
import script from "./VSidebarLayoutHeading.vue?vue&type=script&lang=js&"
export * from "./VSidebarLayoutHeading.vue?vue&type=script&lang=js&"
import style0 from "./VSidebarLayoutHeading.vue?vue&type=style&index=0&id=50c61de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c61de6",
  null
  
)

export default component.exports